interface SpinnerProps {
  className?: string;
}

const DefaultSpinner: React.FC<SpinnerProps> = ({ className }) => {
  return (
    <div
      className={`${className} mt-1.5 relative [&_div]:bg-black/80 dark:[&_div]:bg-white w-16 h-16 inline-block mx-auto spinner rounded-xl [&_div]:w-[4.5%] [&_div]:h-[12%] [&_div]:absolute [&_div]:opacity-0 [&_div]:rounded-full [&_div]:left-[47%] [&_div]:top-[43%]`}
    >
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default DefaultSpinner;
